module.exports = __webpack_public_path__ + "media/images/mtn-6598fbbefb0e9c86b8c80505cfcdd67d.png";